import { render } from "./ReviewModal.vue?vue&type=template&id=f53f8d60&scoped=true"
import script from "./ReviewModal.vue?vue&type=script&lang=js"
export * from "./ReviewModal.vue?vue&type=script&lang=js"

import "./ReviewModal.vue?vue&type=style&index=0&id=f53f8d60&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f53f8d60"]])

export default __exports__